import { useLayoutEffect, useState, RefObject } from "react";

interface ElementSize {
    width: number | undefined;
    height: number | undefined;
}
export function useElementSize(
    ref: RefObject<HTMLDivElement | null>
): ElementSize {
    const [size, setSize] = useState<ElementSize>({
        width: undefined,
        height: undefined,
    });
    useLayoutEffect(() => {
        const element = ref.current;
        if (!element) {
            return;
        }
        const rect = element.getBoundingClientRect();
        setSize({ width: rect.width, height: rect.height });
        const observer = new ResizeObserver(([entry]) => {
            const { width, height } = entry.contentRect;
            setSize({ width, height });
        });
        observer.observe(element);
        return () => observer.disconnect();
    }, [ref]);
    return size;
}
